(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('WarningsListDetailController', WarningsListDetailController);

    WarningsListDetailController.$inject = ['$q', '$state', '$window', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'TabObjects', 'AlertRules', 'WarningsDashboard', 'warName', 'objUniqueCode', 'fleetName'];

    function WarningsListDetailController($q, $state, $window, ParseLinks, AlertService, pagingParams, paginationConstants, TabObjects, AlertRules, WarningsDashboard, warName, objUniqueCode, fleetName) {
        var vm = this;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.changePageSize = changePageSize;
        vm.parseWarningLevel = parseWarningLevel;

        vm.currentState = "warnings-list-detail";
        vm.currentStateFilter = "warnings-list-detail-filter";

        vm.filter = pagingParams.filter;
        vm.predicates = pagingParams.predicates;

        vm.filter.status = "all";
        vm.filter.sizeP = "page";
        vm.filter.warningGetAll = "all";
        vm.filter.warningName = warName;
        vm.filter.warningFleet = fleetName;
        vm.filter.warningObjectCode = objUniqueCode;

        vm.warning = [];
        vm.warningsGroup = [];
        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder != null && retrievedOrder != "null")
            vm.predicates = JSON.parse(retrievedOrder);

        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

        var filter = localStorage.getItem(vm.currentStateFilter);
        if (filter !== null && filter !== "null" && filter !== undefined && filter != "{}") {
            filter = JSON.parse(filter);
            if((filter.warningName != vm.filter.warningName || filter.warningObjectCode != vm.filter.warningObjectCode) && (vm.filter.warningName != "" && vm.filter.warningObjectCode != "")){
                localStorage.setItem(vm.currentStateFilter, JSON.stringify(vm.filter));
            } else {
                if (Object.keys(filter).length > 0) {
                    vm.filter = filter;
                }
            }
        } else {
            localStorage.setItem(vm.currentStateFilter, JSON.stringify(vm.filter));
        }

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc'));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        function loadAll(notify) {
            var page = {
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                sort: null,
                search: vm.searchParams
            };

            WarningsDashboard.search(page, vm.filter, innerOnSuccess, onError);

            function innerOnSuccess(data, headers) {
                vm.showClose = vm.filter.status !== 'open';
                onSuccess(data, headers, notify);
            }
        }

        function onSuccess(data, headers, notify) {
            vm.warning = data;
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.listFilter = pagingParams.filter;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function transition(notify) {
            notify = notify == false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: null,
                predicates: vm.predicates,
                search: vm.searchParams,
                filter: vm.filter,
                itemsPerPageChosen: vm.itemsPerPageChosen,
                name: vm.filter.warningName,
                objectUniqueCode: vm.filter.warningObjectCode,
                fleet: vm.filter.warningFleet
            }, {notify: notify, location: "replace"});
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function parseWarningLevel(level) {
            return "warning-level " + (level === 1 ? "lv-low" : level === 2 ? "lv-medium" : "lv-high");
        }

        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            vm.loadAll(false);
        }

        vm.showDetail = function (warning) {
            TabObjects.byUniqueCode({uniqueCode: warning.objectUniqueCode}).$promise.then(function (object) {
                AlertRules.get({id: warning.warningId}).$promise.then(function (rule) {
                    var date = new Date(warning.date);
                    var range = 1800;
                    if(rule.frequency > range) {
                        range = rule.frequency;
                    }
                    var dateTo;
                    if(warning.status === "close") {
                        dateTo = new Date(warning.dateClose).getTime() + 600000;
                    } else {
                        dateTo = date.getTime() + ((+range + 1800) * 1000);
                    }
                    $state.transitionTo('tab-objects-dashboard-detail', {
                        id: object.id,
                        fleet: warning.fleetId,
                        objType: object.objectType.id,
                        warningName: warning.name,
                        warningDateFrom: date.setTime(date.getTime() - (range * 1000)),
                        warningDateTo: date.setTime(dateTo)
                    }, {notify: true, location: "replace"});
                });
            });
        };

        vm.loadAll(false);
    }
})
();

